import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { useModelCompareTranslation } from '../../../../../../constants/modelCompareData/translations/useModelCompareTranslation.mjs';
import { EmptyPropertyTitleGridItem, NotesWrap, Note, CenterPlaceholderGridItem } from '../../../CompareTable.styles.mjs';
"use strict";
const Notes = ({
  products
}) => {
  const {
    formatMessage
  } = useModelCompareTranslation();
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx(EmptyPropertyTitleGridItem, {
      stickX: true
    }), products.map((product, index) => product?.notes?.length ? /* @__PURE__ */jsx(NotesWrap, {
      children: product.notes.map((note, i) => /* @__PURE__ */jsx(Note, {
        children: formatMessage(note)
      }, i))
    }, `${product.id}-${index}`) : /* @__PURE__ */jsx(CenterPlaceholderGridItem, {}, `${product.id}-${index}`))]
  });
};
export { Notes };
//# sourceMappingURL=Notes.mjs.map
